import { render, staticRenderFns } from "./FlexMessage.vue?vue&type=template&id=26e50ccc&"
import script from "./FlexMessage.vue?vue&type=script&lang=js&"
export * from "./FlexMessage.vue?vue&type=script&lang=js&"
import style0 from "./FlexMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports